<ui-message-custom class="font-md d-block mt-3 sold-out-wrap">
  <span [translate]="'orderProcess.delivery.soldOutOn'"></span> {{days}}.
</ui-message-custom>
